import React from "react";

import { Slot } from "~/components/slot";

const LazyValue = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Value } = await import("@radix-ui/react-select");

	return { default: Value };
});

export type SelectValueProps = React.ComponentProps<typeof LazyValue>;

export const SelectValue = React.forwardRef<React.ElementRef<typeof LazyValue>, SelectValueProps>(
	({ asChild = false, ...props }, ref) => {
		const Root = asChild ? Slot : "span";

		return (
			<React.Suspense fallback={<Root ref={ref} {...props} />}>
				<LazyValue asChild={asChild} ref={ref} {...props} />
			</React.Suspense>
		);
	},
);
